/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Date/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Date({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Topbar/Content/DateSelector/Date"
  
}) {
let tabIsFullWidthValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'is_full_width',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let tabSelectedDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.date',
})
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let tabIsFullWidthValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'is_full_width',
})
let aggregateData = fromHelpers.formatDate(tabSelectedDateValueData, tabSelectedTimeZoneIdValueData, tabIsFullWidthValueData1)
let dtTysiabuttontextColorSecondaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.secondary.active'
        })
  return (<React.Fragment
>
<div
  data-testid="Date.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-9lso': dtColorsNeutral300,'--pl-2-9lso': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-3-9lso': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--w-4-9lso': tabIsFullWidthValueData ? "212px" : "112px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="tab.selected.date"
 data="tab.selected.time_zone_id"
 data="tab.is_full_width"
 aggregate="helpers.js formatDate"
 text={aggregateData}
 color={dtTysiabuttontextColorSecondaryActive}
 weight="medium"
 textOverflow="ellipsis"
 whiteSpace="nowrap"
/>
</div>
{children}
</React.Fragment>)
}